import { render } from "./LoaderView.vue?vue&type=template&id=29009c89&scoped=true&ts=true"
import script from "./LoaderView.vue?vue&type=script&lang=ts"
export * from "./LoaderView.vue?vue&type=script&lang=ts"

import "./LoaderView.vue?vue&type=style&index=0&id=29009c89&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29009c89"]])

export default __exports__